export const SEPARATOR_CHAR = '/'
